const logotext = 'Jo Ledesma'
const meta = {
  title: "Jo Ledezma",
  description: "Soy Jo Ledezma photographer",
};

const introdata = {
  title: "Jo Ledezma PH",
  animated: {
    first: "fotografia profesional",
    second: "apasionado por el deporte",
    third: "registrando los momentos con mi camara",
  },
  description: "Fotografo profesional",
  your_img_url: "https://imagizer.imageshack.com/v2/1024x768q70/923/qgjR77.jpg"
};

const dataabout = {
  title: "un poco acerca de mi",
  aboutme1: `La fotografía es mi pasión, mi trabajo y una parte importantísima de mi vida.`,
  aboutme2: `Mi nombre es Jorge Ledezma. Soy de la provincia de Tucumán precisamente de la Capital, soy un enamorado de la fotografía y he convertido mi pasión en mi trabajo. Para mí la fotografía es un arte y como tal, cada toma debe expresar y despertar emociones.`,
  aboutme3: `En mis fotografías se refleja mi constante búsqueda de la perfección, primero en la captura de la imagen y luego en el posterior retoque digital, dando siempre un enfoque artístico y original. Quiero que cada una de mis fotografías genere un impacto visual en quién las observe.`,
  aboutme4: `Me considero cercano, tratando a mis clientes como personas antes que como clientes. Personas que, en ocasiones, llegan a convertirse en amigos.`,
  aboutme5: `Actualmente como fotógrafo profesional, me gusta capturar tus momentos especiales, como el día de tu boda, tu aniversario, el bautizo de tu niño, una comunión o cualquier otro acontecimiento social.`,
  aboutme6:`¡Gracias por visitar mi página!`
};
const worktimeline = [
  {
    jobtitle: "Eventos Sociales",
    // where: "Ext. Atletico Tucuman",
    // date: "2024",
  },
  {
    jobtitle: "Fotografo deportivo",
    where: "Club Atletico Tucuman",
    // date: "2024",
  },
  {
    jobtitle: "Festivales y Ceremonias",
    // where: "En ciudades o conciertos",
    // date: "2024",
  }
];

const skills = [
  {
    name: "Javascript",
    value: 40,
  },
  {
    name: "Node.Js",
    value: 40,
  },
  {
    name: "MongoDB",
    value: 30,
  },
  {
    name: "Sql",
    value: 30,
  },
  {
    name: "Cypress",
    value: 70,
  },
  {
    name: "MochaJS",
    value: 70,
  },
];

const services = [
  {
    title: "Fotografia de eventos",
    description:
      "Experiencia en capturar los momentos mas especiales",
  },
  {
    title: "Fotografia deportiva",
    description:
      "Segun la banda de goles y el crack de PG, las mejores fotos del deca las saco yo",
  },
];

const dataportfolio = [
  {
    img: "https://picsum.photos/1024/800?random=",
    description: "Bodas",
    link: "/bodas",
  },
  {
    img: "https://picsum.photos/1024/800?random=",
    description: "Atletico Tucuman",
    link: "/atleticoTucuman",
  },
  {
    img: "https://picsum.photos/1024/800?random=",
    description: "Liga tucumana de futbol",
    link: "/ligaTucumana",
  },
  {
    img: "https://picsum.photos/1024/800?random=",
    description: "Deportistas profesionales",
    link: "/deportistasProfesionales",
  }
];

const databoda = [
  {
    img: "https://picsum.photos/1024/800?random=",
    description: "1",
    link: "#",
  },
  {
    img: "https://picsum.photos/600/800?random=",
    description: "2",
    link: "#",
  },
  {
    img: "https://picsum.photos/600/800?random=",
    description: "3",
    link: "#",
  },
  {
    img: "https://picsum.photos/600/800?random=",
    description: "4",
    link: "#",
  },
  {
    img: "https://picsum.photos/600/800?random=",
    description: "5",
    link: "#",
  },
];

const datadeportistas = [
  {
    img: "https://picsum.photos/1024/800?random=",
    description: "1",
    link: "#",
  },
  {
    img: "https://picsum.photos/1024/800?random=",
    description: "2",
    link: "#",
  },
  {
    img: "https://picsum.photos/1024/800?random=",
    description: "3",
    link: "#",
  },
  {
    img: "https://picsum.photos/1024/800?random=",
    description: "4",
    link: "#",
  },
  {
    img: "https://picsum.photos/1024/800?random=",
    description: "5",
    link: "#",
  },
  {
    img: "https://picsum.photos/1024/800?random=",
    description: "6",
    link: "#",
  },
  {
    img: "https://picsum.photos/1024/800?random=",
    description: "7",
    link: "#",
  },
];

const dataligatucumana = [
  {
    img: "https://picsum.photos/1024/800?random=",
    description: "1",
    link: "#",
  },
  {
    img: "https://picsum.photos/1024/800?random=",
    description: "2",
    link: "#",
  },
  {
    img: "https://picsum.photos/1024/800?random=",
    description: "3",
    link: "#",
  },
  {
    img: "https://picsum.photos/1024/800?random=",
    description: "4",
    link: "#",
  },
  {
    img: "https://picsum.photos/1024/800?random=",
    description: "5",
    link: "#",
  },
  {
    img: "https://picsum.photos/1024/800?random=",
    description: "6",
    link: "#",
  },
  {
    img: "https://picsum.photos/1024/800?random=",
    description: "7",
    link: "#",
  },
];

const dataat = [
    {
        img: "https://picsum.photos/1024/800?random=",
        description: "1",
        link: "#",
      },
      {
        img: "https://picsum.photos/1024/800?random=",
        description: "2",
        link: "#",
      },
      {
        img: "https://picsum.photos/1024/800?random=",
        description: "3",
        link: "#",
      },
      {
        img: "https://picsum.photos/1024/800?random=",
        description: "4",
        link: "#",
      },
      {
        img: "https://picsum.photos/1024/800?random=",
        description: "5",
        link: "#",
      },
      {
        img: "https://picsum.photos/1024/800?random=",
        description: "6",
        link: "#",
      },
      {
        img: "https://picsum.photos/1024/800?random=",
        description: "7",
        link: "#",
      },
];

const contactConfig = {
  YOUR_EMAIL: "jorge.manuel.Ledezma@hotmail.com",
  YOUR_PHONE: "+54 9 3815 57-4043",
  description: "",
  // creat an emailjs.com account
  // check out this tutorial https://www.emailjs.com/docs/examples/reactjs/
  YOUR_SERVICE_ID: "service_hkxi1kp",
  YOUR_TEMPLATE_ID: "template_nmbody3",
  YOUR_USER_ID: "pablogiroud",
  PUBLIC_KEY: "_YzIi3YKPEVBWYDHN",
};

const socialprofils = {
  github: "",
  facebook: "https://facebook.com/joledezmafotografias",
  instagram: "https://www.instagram.com/joledezmafotografias",
  linkedin: "",
  twitter: "https://twitter.com/joledezmaphoto",
};
export {
  meta,
  dataabout,
  dataat,
  datadeportistas,
  dataligatucumana,
  dataportfolio,
  databoda,
  worktimeline,
  skills,
  services,
  introdata,
  contactConfig,
  socialprofils,
  logotext,
};
